export enum SubscriptionTeamSize {
    UpToFive = 5,
    UpToTen = 10,
}
